module.exports = __webpack_public_path__ + "static/our-final-invention-7c440f494793636f5d52a45eba916017.jpg";